import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#111d2e',
            border: '1px solid #1e2d3d',
            color: '#e2eaf4',
            fontFamily: "'IBM Plex Sans', sans-serif",
            fontSize: '0.82rem',
          },
        }}
      />
    </AuthProvider>
  </BrowserRouter>
);
